<!--
 * @Description: 商品批次追溯
 * @Author: WuPuyi
 * @LastEditors: WuPuyi
 * @Date: 2020-12-02 10:00:44
 * @LastEditTime: 2020-12-11 14:15:06
-->
<template>
  <div
    class="batch-circulation"
    v-loading="loading"
    element-loading-text="拼命加载中"
  >
    <e6-title>商品批次流通追溯详情</e6-title>
    <section class="batch-circulation-container">
      <div class="batch-circulation-content">
        <div class="main">
          <div class="item goods-info">
            <div class="item-title">
              <h2 class="item-title--content">商品信息</h2>
              <span class="item-title--btn"></span>
            </div>
            <div class="item-content">
              <el-form label-width="200px">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="追溯码">
                      {{ goodsDetail.tagCode }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="商品名称">
                      {{ goodsDetail.productName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="生产厂商">
                      {{ goodsDetail.manufacturer }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="所属商户">
                      {{ goodsDetail.companyName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="商户联系方式">
                      {{ goodsDetail.companyTel }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="厂商地址">
                      {{ goodsDetail.productionAddress }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-if="goodsDetail.isImport === 1">
                    <el-form-item label="原产地">
                      {{ goodsDetail.countryName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-if="goodsDetail.isImport === 1">
                    <el-form-item label="入境口岸">
                      {{ goodsDetail.portName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-if="goodsDetail.isImport === 1">
                    <el-form-item label="入境日期">
                      {{ goodsDetail.entryDate }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
          <div class="item batch-circulation-item">
            <div class="item-title">
              <h2 class="item-title--content">批次流通详情</h2>
            </div>
            <div class="item-content">
              <vue2-org-tree
                :data="data"
                horizontal
                label-class-name="org-tree-bg"
                :renderContent="batchFlowDetailTreeRender"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="batch-circulation-footer">
        <el-button class="goback-btn" @click="handleGoBack">返回</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import {
  fetchGoodsByTagCode,
  fetchBatchTraceDetail
} from "@/api/goodsTrace/goodsTrace.js";
import { cloneDeep } from "lodash";
import moment from "moment";

export default {
  data() {
    return {
      data: {},
      goodsDetail: {
        tagCode: "", // 追溯码
        productName: "", // 商品名称
        manufacturer: "", // 生产厂商
        companyName: "", // 所属商户
        companyTel: "", // 商户联系方式
        productionAddress: "", // 厂商地址
        isImport: "", // 是否进口 1-是 0-否
        countryName: "", // 原产国/地
        portName: "", // 口岸名称（入境口岸）
        entryDate: "" // 入境日期
      },
      tagCode: "",
      loading: false
    };
  },
  created() {
    let { tagCode } = this.$route.query;
    this.tagCode = tagCode;
    this.init();
  },
  methods: {
    // 初始化数据
    async init() {
      try {
        this.loading = true;
        let goodsRes = await fetchGoodsByTagCode({
          tagCode: this.tagCode
        });

        if (goodsRes.code === 1 && goodsRes.result) {
          this.goodsDetail = cloneDeep(goodsRes.result);

          let batchFlowDetailRes = await fetchBatchTraceDetail({
            warehouseId: goodsRes.result.warehouseId
          });

          if (batchFlowDetailRes.code === 1 && batchFlowDetailRes.result) {
            this.data = cloneDeep(batchFlowDetailRes.result);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    batchFlowDetailTreeRender(h, data) {
      console.log(data);
      if (data.pid === "0") {
        return (
          <div class="org-tree-bg-node">
            <p>商品名称：{data.label}</p>
            <p>入库编码：{data.warehouseCode}</p>
            <p>
              入库时间：
              {moment(data.warehouseTime).format("YYYY年MM月DD HH:mm:ss")}
            </p>
            <p>同批次入库数量：{data.warehouseNum}件</p>
          </div>
        );
      } else {
        return (
          <div class="org-tree-bg-node">
            <p>
              {data.storageName}（{data.consigneeName}）
            </p>
            <p>
              出库时间：
              {moment(data.warehouseTime).format("YYYY年MM月DD HH:mm:ss")}
            </p>
            <p>出库数量：{data.warehouseNum}件</p>
          </div>
        );
      }
    },
    // 返回
    handleGoBack() {
      this.$router.push({
        path: "/goodsTraceWholeProcess",
        query: {
          tagCode: this.tagCode
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.batch-circulation {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: #edf1f6;
}
.batch-circulation-container {
  position: relative;
  width: 100%;
  height: calc(100% - 39px);
  background-color: #ffffff;
  margin-top: 10px;
  border-radius: 4px;
  box-shadow: 0px 0px 8px 0px rgba(62, 67, 244, 0.1);
}
.batch-circulation-content {
  width: 100%;
  height: calc(100% - 56px);
  overflow-y: auto;
  .main {
    width: 100%;
    .item {
      width: 100%;
      .item-title {
        box-sizing: border-box;
        width: 100%;
        height: 42px;
        line-height: 42px;
        padding: 0 20px;
        background: #fafbfc;
        border: 1px solid #edf0f5;
        display: flex;
        justify-content: space-between;
        &--content {
          margin: 0;
          font-size: 14px;
          line-height: 42px;
          font-weight: bold;
          color: #303133;
        }
      }
    }
  }
  .goods-info {
    .item-content {
      padding-top: 20px;
      /deep/.el-form {
        .el-form-item__label {
          font-size: 14px;
          color: #849bbd;
        }
        .el-form-item__content {
          font-size: 14px;
          color: #606266;
        }
      }
    }
  }
  .batch-circulation-item {
    .item-content {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 50px 0;
      /deep/.org-tree-node {
        &::before {
          border-width: 2px;
          border-color: #c2cede;
        }
        &::after {
          border-width: 2px;
          border-color: #c2cede;
        }
      }
      /deep/.org-tree-node-children {
        &::before {
          border-width: 2px;
          border-color: #c2cede;
        }
      }
      /deep/.org-tree-bg {
        color: #fff;
        background-color: #46bfea;
      }
      /deep/.org-tree-bg-node {
        & > p {
          margin: 0;
          line-height: 1.5;
          text-align: left;
        }
      }
    }
  }
}
// 底部返回
.batch-circulation-footer {
  width: 100%;
  height: 56px;
  background-color: #fafbfc;
  border: 1px solid #edf0f5;
  box-shadow: 0px -1px 10px 0px rgba(0, 0, 0, 0.07);
  line-height: 56px;
  text-align: center;
  .goback-btn {
    width: 100px;
    height: 36px;
    background: #dae1eb;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #909399;
  }
}
</style>
